import { Environment } from 'ha/config';

export enum OneTrustCategoryNames {
  strictlyNecessary = 'Strictly Necessary Cookies',
  performance = 'Performance Cookies',
  functional = 'Functional Cookies',
  targeting = 'Targeting Cookies',
  socialMedia = 'Social Media Cookies',
}

export enum OneTrustCategoryIds {
  strictlyNecessary = 'C0001',
  performance = 'C0002',
  functional = 'C0003',
  targeting = 'C0004',
  socialMedia = 'C0005',
}

export interface CookieItem {
  Host: string;
  Name: string;
  description: string;
  Length: string;
}

export interface Group {
  OptanonGroupId: OneTrustCategoryIds;
  GroupName: OneTrustCategoryNames;
  GroupDescription: string;
  GroupId: string;
  Cookies: CookieItem[];
}

export interface DomainData {
  Groups: Group[];
  CookieListDescription: string;
}

export interface OneTrustOptions {
  env: Environment;
  key: string;
}
